import {decorate, observable, action} from 'mobx';
import _ from 'lodash';

class SparePartsFinderStore {
    marketDisable = false;

    setMarketDisable(value) {
        this.marketDisable = value;
    }
}

decorate(SparePartsFinderStore, {
    marketDisable: observable,
    setMarketDisable: action,
})

const store = new SparePartsFinderStore();
export default store;